<template>
  <div class="flex flex-col p-2">
    <!-- <div>
      <div class="bg-gray-100 rounded-md shadow rounded-md overflow-hidden border-b border-gray-200">
        Schedule
      </div>
    </div> -->
    <div class="flex flex-col justify-center"
      v-if="displayLoadingStops">
      <Spinner class="py-4"
        message="Loading Stop Information"
        :size="16"
      />
    </div>
    <div v-if="error">
      <div class="bg-red-200 p-2">
        <span>{{ error }}</span>
      </div>
    </div>
    <div class="w-full h-[550px] min-h-96 flex flex-row">
      <div class="w-3/4">
        <div ref="map"></div>
      </div>
      <div class="flex flex-col w-1/4 p-2">
        <div class="flex flex-row p-3 justify-between items-baseline">
          <div>
            Logged Before:
          </div>
          <TimeField
            v-model="loggedBefore"
          />
        </div>
        <Table>
          <template #rows>
            <tr>
              <td class="px-2.5 py-2 whitespace-nowrap text-sm font-medium text-gray-500"><img src="@/assets/icons/School.svg"/></td>
              <td class="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-500">School</td>
            </tr>
            <tr>
              <td class="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-500"><img src="@/assets/icons/Bus.svg"/></td>
              <td class="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-500">Driver Location</td>
            </tr>
            <tr>
              <td class="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-500"><img src="@/assets/icons/Home.svg"/></td>
              <td class="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-500">Stop</td>
            </tr>
            <tr v-if="extraStops.length > 0">
              <td class="px-2.5 py-2 whitespace-nowrap text-sm font-medium text-gray-500"><img src="@/assets/icons/HomeAlt.svg"/></td>
              <td class="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-500">Recorded Stop Location</td>
            </tr>
          </template>
        </Table>
        <Table>
          <template #columns>
            <th class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
              Driver
            </th>
          </template>
          <template #rows>
            <td class="px-2 py-2 whitespace-nowrap text-sm text-gray-500">
              {{ driverName }}
            </td>
          </template>
        </Table>
        <Table>
          <template #columns>
            <th class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
              <div class="flex flex-row items-center gap-2" title="Actual vehicle recorded for this route.">
                Vehicle
                <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px"
                  fill="#6b7280">
                  <path
                    d="M480-240q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-36-153h73q0-37 6.5-52.5T555-485q35-34 48.5-58t13.5-53q0-55-37.5-89.5T484-720q-51 0-88.5 27T343-620l65 27q9-28 28.5-43.5T482-652q28 0 46 16t18 42q0 23-15.5 41T496-518q-35 32-43.5 52.5T444-393Zm36 297q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
                </svg>
              </div>
            </th>
          </template>
          <template #rows>
            <td class="px-2 py-2 whitespace-nowrap text-sm text-gray-500">
              <template v-if="showVehicleInfo">
                <div v-if="vehicleExternalId" class="font-medium text-indigo-600 hover:underline">
                  <button @click="toVehicleForm">{{ vehicleDisplayName || 'Vehicle' }}</button>
                </div>
                <div v-else class="font-medium">
                  {{ vehicleDisplayName || 'N/A' }}
                </div>
                <div v-if="vehicleLicensePlate" class="text-xs text-gray-400">
                  License Plate {{ vehicleLicensePlate }}
                </div>
              </template>
              <template v-else>
                N/A
              </template>
            </td>
          </template>
        </Table>
      </div>
    </div>
    <div class="w-full flex flex-col">
      <Table v-if="showTable">
        <template #columns>
          <th
            v-for="(column, index) in stopTableColumns"
            :key="index"
            :title="stopTableColumnTitles[index]"
            scope="col"
            class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
            <div class="flex flex-row items-center gap-2">
              {{ column }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16px"
                viewBox="0 -960 960 960"
                width="16px"
                fill="#6b7280">
                <path d="M480-240q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-36-153h73q0-37 6.5-52.5T555-485q35-34 48.5-58t13.5-53q0-55-37.5-89.5T484-720q-51 0-88.5 27T343-620l65 27q9-28 28.5-43.5T482-652q28 0 46 16t18 42q0 23-15.5 41T496-518q-35 32-43.5 52.5T444-393Zm36 297q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z"/>
              </svg>
            </div>
          </th>
        </template>
        <template #rows>
          <tr
            v-for="(stop, index) in stopsDisplay"
            :key="index"
            class="bg-white even:bg-gray-50">
            <td class="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-500">
              {{ stop.sequence }}
            </td>
            <td class="px-2 py-2 whitespace-nowrap text-sm text-gray-500">
              {{ timeToDisplay(stop.time) }}
            </td>
            <td class="px-2 py-2 whitespace-nowrap text-sm text-gray-500">
              {{ stop.completedAt ? timeToDisplay(stop.completedAt) : '' }}
            </td>
            <td v-if="showRouteTimes" class="px-2 py-2 whitespace-nowrap text-sm text-gray-500">
              {{ stop.arrivalTime ? timeToDisplay(stop.arrivalTime) : '' }}
            </td>
            <td v-if="showRouteTimes" class="px-2 py-2 whitespace-nowrap text-sm text-gray-500">
              {{ stop.departureTime ? timeToDisplay(stop.departureTime) : '' }}
            </td>
            <td class="flex flex-col px-2 py-2 whitespace-nowrap text-sm text-gray-500">
              <div
                v-for="student in stop.pickupStudents"
                :key="student.db_id">
                <span class="font-bold">↑</span>
                {{ `${student.firstName} ${student.lastName}` }}
              </div>
              <div
                v-for="student in stop.dropoffStudents"
                :key="student.db_id">
                {{ `${student.firstName} ${student.lastName}` }}
                <span class="font-bold">↓</span>
              </div>
            </td>
          </tr>
        </template>
      </Table>
      <RouteStudentList
        :students="students"
        @mouseover="onMouseOver"
      />
    </div>
    <div id="tooltip" ref="tooltipRef"></div>
  </div>
</template>

<style>
#tooltip {
  position: relative;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
}
</style>

<script>
import Map from 'ol/Map.js'
import { Feature, View, Overlay } from 'ol'
import TileLayer from 'ol/layer/Tile'
import { OSM } from 'ol/source'
import { LineString, Point } from 'ol/geom'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Style from 'ol/style/Style'
import Stroke from 'ol/style/Stroke'
import Icon from 'ol/style/Icon.js'
import Fill from 'ol/style/Fill'
import Text from 'ol/style/Text'
import { transform } from 'ol/proj'

import TimeField from './formComponents/TimeField.vue'
import Table from './Table.vue'
import Spinner from './Spinner.vue'
import RouteStudentList from './RouteList/RouteStudentList.vue'

import { route as routeApi } from '../services/api.js'
import { padStart, isArray } from 'lodash'
import cloneDeep from 'clone-deep'
import fastDeepEquals from 'fast-deep-equal'

import user from '../services/user/user.js'
import time from '../services/utils/time.js'

function addTimeZoneOffset(dateObject) {
  let offsetMinutes = dateObject.getTimezoneOffset()
  if (offsetMinutes !== 0) {
    let offsetHour = Math.floor(offsetMinutes / 60)
    let offsetDirection = (offsetMinutes > 0) ? '-' : '+'
    return `${offsetDirection}${padStart(offsetHour, 2, '0')}:${padStart(offsetMinutes % 60, 2, '0')}`
  }
  else {
    return 'Z'
  }
}

export default {
  components: {
    TimeField,
    Table,
    Spinner,
    RouteStudentList,
  },
  props: {
    title: undefined,
    date: undefined,
    routeId: undefined,
    direction: undefined,
    studentsProp: Array,
    showRouteTimes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user: undefined,

      prevParams: {
        routeId: undefined,
        date: undefined,
      },

      map: undefined,
      vectorSource: undefined,
      loggedBefore: undefined,
      showTable: false,
      showTooltip: false,

      displayLoadingStops: true,

      stops: [],
      stopTimes: [],
      extraStops: [],
      points: [],
      allPoints: [],
      intervalId: undefined,
      error: undefined,
      centered: false,
      tooltip: undefined,
      driverName: undefined,
      vehicleExternalId: undefined,
      vehicleColor: undefined,
      vehicleMake: undefined,
      vehicleModel: undefined,
      vehicleLicensePlate: undefined,
      routeCompleted: false,

      mouseOverStudentId: undefined,

      studentColumns: ['Internal ID', 'Name', 'Accommodations'],
      scheduleColumns: ['Weekday', 'Start Time', 'End Time'],

      stopsDisplay: [],

      studentsApi: undefined,
      stopsDetailApi: undefined,

      stopDataApi: undefined,
    }
  },
  methods: {
    toVehicleForm() {

      if (!this.vehicleExternalId) return
      this.$router.push({
        name: 'VehicleForm',
        params: { vehicleId: this.vehicleExternalId },
      })
    },
    prepareDataForDisplay() {
      if (this.stopsDetailApi) {
        if (isArray(this.stops) && this.stops.length > 0) {
          this.stopsDisplay = cloneDeep(this.stops)

          this.stopsDetailApi.sort((a, b) => a.sequence - b.sequence)
          this.stopsDisplay.sort((a, b) => a.sequence - b.sequence)

          for (const [index, stopData] of this.stopsDetailApi.entries()) {
            if (this.stopsDisplay[index].sequence === stopData.sequence) {
              this.stopsDisplay[index].pickupStudents = stopData.pickup_students
              this.stopsDisplay[index].dropoffStudents = stopData.dropoff_students
            }
          }
        }
        else {
          this.stopsDisplay = cloneDeep(this.stopsDetailApi)
          this.stopsDisplay.sort((a, b) => a.sequence - b.sequence)
        }
      }
    },
    findStopADs() {
      if (this.allPoints.length === 0) {
        return
      }

      let index = 0
      let currStop = this.stops[0]
      let inRange = false
      if (
        this.calculateDistance(
          [currStop.longitude, currStop.latitude], 
          [this.allPoints[0].longitude, this.allPoints[0].latitude]) 
          < (currStop.closestPoint + 100)){
        inRange = true
      }
      for(let i = 0; i < this.allPoints.length; i++){
        currStop = this.stops[index]
        if (currStop.completedAt === undefined) {
          return
        }
        let stopPoint = [currStop.longitude, currStop.latitude]
        let point = [this.allPoints[i].longitude, this.allPoints[i].latitude]
        if(inRange){
          if(this.calculateDistance(stopPoint, point) > (currStop.closestPoint + 100)){
            if(index == this.stops.length-1){
              break
            }
            currStop.departureTime = this.allPoints[i].loggedAtLocal
            inRange = false
            index++
          }
        } else {
          if(this.calculateDistance(stopPoint, point) < (currStop.closestPoint + 100)){
            currStop.arrivalTime = this.allPoints[i].loggedAtLocal
            inRange = true
          }
        }
      }
    },
    closestToPoint(point, pointArr){
      let closest = pointArr[0]
      for(let i=1; i<pointArr.length; i++){
        if(this.calculateDistance(point, closest) > this.calculateDistance(point, pointArr[i])){
          closest = pointArr[i]
        }
      }
      return closest
    },
    calculateDistance(point1, point2){
      return Math.sqrt(
        Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2)
      ) * 364320
    },
    timeToDisplay(_time) {
      return time.timeToDisplay(_time)
    },
    async getRouteDetail() {
      try {
        this.prevParams = {
          routeId: String(this.routeId),
          date: String(this.date),
        }
        this.displayLoadingStops = true
        await user.ready()
        let response = await routeApi.getRouteDetail(this.routeId, { date: this.date })
        this.displayLoadingStops = false

        if (response.status !== 200) {
          throw new Error(response.data)
        }
        let data = response.data

        this.studentsApi = data.students
        if (data.no_rides.length > 0){
          for (let noRide of data.no_rides) {
            const student = this.studentsApi[this.studentsApi.findIndex(e => e.db_id == noRide.student.db_id)]
            if (student !== undefined) {
              this.$set(student, 'noRide', true)
            }
          }
        }
        changeStudentKeys(this.studentsApi)
        for (const studentAccommodation of data.student_data) {
          let studentApiObj = this.studentsApi.find((curr) => studentAccommodation.dbId === curr.db_id)
          if (studentApiObj) {
            studentApiObj.accommodations = studentAccommodation.accommodations
          }
        }
        this.stopsDetailApi = data.detail.stops

        for (const stopData of this.stopsDetailApi) {
          changeStudentKeys(stopData.students)
          changeStudentKeys(stopData.pickup_students)
          changeStudentKeys(stopData.dropoff_students)
        }

        this.prepareDataForDisplay()
      }
      catch (error) {
        this.displayLoadingStops = false
        console.error(error)
      }
      function changeStudentKeys(studentDataArray) {
        for (const studentData of studentDataArray) {
          studentData.dbId = studentData.db_id
          studentData.internalId = studentData.internal_id
          studentData.firstName = studentData.first_name
          studentData.lastName = studentData.last_name
          studentData.middleName = studentData.middle_name
        }
      }
    },
    initializeMap() {
      const mapEl = this.$refs.map
      this.map = new Map({
        target: mapEl,
        layers: [new TileLayer({ source: new OSM() })]
      })

      this.vectorSource = new VectorSource()
      const layer = new VectorLayer({
        source: this.vectorSource,
        style: function (feature) {
          switch (feature.get('type')) {
            case 'route':
              return new Style({
                stroke: new Stroke({
                  width: 6,
                  color: [66, 133, 244, 1]
                })
              })
            case 'currentPoint':
              return new Style({
                image: new Icon({
                  src: require('@/assets/icons/Bus.svg'),
                  imgSize: [32, 32],
                  scale: 1,
                  anchor: [0.5, 0.25],
                  imageLoadFunction: function(image, src) {
                    image.getImage().src = src
                    image.getImage().onerror = () => {
                      console.error('Failed to load icon:', src)
                    }
                  }
                }),
              })
            case 'stopPoint':
              if (feature.get('school') === true) {
                return new Style({
                  image: new Icon({
                    src: require('@/assets/icons/School.svg'),
                    imgSize: [32, 32],
                    scale: 1,
                    anchor: [0.5, 0.25],
                    imageLoadFunction: function(image, src) {
                      image.getImage().src = src
                      image.getImage().onerror = () => {
                        console.error('Failed to load icon:', src)
                      }
                    }
                  }),
                  text: new Text({
                    font: '16px Calibri,sans-serif',
                    fill: new Fill({
                      color: '#000'
                    }),
                    stroke: new Stroke({
                      color: '#fff',
                      width: 2
                    }),
                    offsetY: -15,
                    text: feature.get('name') 
                  })
                })
              } else {
                return new Style({
                  image: new Icon({
                    src: require('@/assets/icons/Home.svg'),
                    imgSize: [32, 32],
                    scale: 1,
                    anchor: [0.5, 0.25],
                    imageLoadFunction: function(image, src) {
                      image.getImage().src = src
                      image.getImage().onerror = () => {
                        console.error('Failed to load icon:', src)
                      }
                    }
                  }),
                  text: new Text({
                    font: '16px Calibri,sans-serif',
                    fill: new Fill({
                      color: '#000'
                    }),
                    stroke: new Stroke({
                      color: '#fff',
                      width: 2
                    }),
                    offsetY: -15,
                    text: feature.get('name') 
                  })
                })
              }
            // case 'extraStopPoint':
            //   if (feature.get('school')===true){
            //     return new Style({
            //       image: new Icon({
            //         src: require('@/assets/icons/SchoolAlt.svg'),
            //         imgSize: [32, 32],
            //         scale: 1,
            //         anchor: [0.5, 0.25],
            //         imageLoadFunction: function(image, src) {
            //           image.getImage().src = src;
            //           image.getImage().onerror = () => {
            //             console.error('Failed to load icon:', src);
            //           };
            //         }
            //       }),
            //     })
            //   } else {
            //     return new Style({
            //       image: new Icon({
            //         src: require('@/assets/icons/HomeAlt.svg'),
            //         imgSize: [32, 32],
            //         scale: 1,
            //         anchor: [0.5, 0.25],
            //         imageLoadFunction: function(image, src) {
            //           image.getImage().src = src;
            //           image.getImage().onerror = () => {
            //             console.error('Failed to load icon:', src);
            //           };
            //         }
            //       }),
            //     })
            //   }
          }
        }
      })
      this.map.addLayer(layer)
      this.map.setView(
        new View({
          zoom: 14
        })
      )
      this.tooltip = new Overlay({
        element: this.$refs.tooltipRef,
        offset: [10, 0],
        positioning: 'bottom-left',
      })

      this.map.addOverlay(this.tooltip)

      this.map.on('pointermove', (evt) => {
        const feature = this.map.forEachFeatureAtPixel(evt.pixel, 
          (feature) => feature
        )

        if (feature !== this.hoveredFeature) {
          if (feature) {
            // Mouse entered new feature
            this.hoveredFeature = feature
          }
        }

        // Change cursor style
        if (feature) {
          this.map.getTargetElement().style.cursor = 'pointer'
        } else {
          this.map.getTargetElement().style.cursor = ''
        }

        if (feature && feature.get('loggedAt')) {
          if (feature.get('type') === 'route' ) {
            this.$refs.tooltipRef.innerHTML = feature.get('loggedAt')
            this.tooltip.setPosition(evt.coordinate)
          } else {
            const geometry = feature.getGeometry()
            const coordinate = geometry.getCoordinates()
            this.$refs.tooltipRef.innerHTML = feature.get('loggedAt')
            this.tooltip.setPosition(coordinate)
          }
        } else {
          this.tooltip.setPosition(undefined)
        }
      })
    },
    async updateMap() {
      this.user = await user.get()

      if (this.user.can('view_internal_cst_data')) {
        this.showTable = true
      }

      let endAt
      if (this.loggedBefore) {
        endAt = `${this.date}T${this.loggedBefore}${addTimeZoneOffset(new Date())}`
      }
      else {
        endAt = `${this.date}T23:59:59${addTimeZoneOffset(new Date())}`
      }

      console.log(endAt)
      const res = (await routeApi.getRouteMapPoints(this.routeId, endAt))
      const data = res.data

      if (data.error) {
        if (data.error === 'Unable to get points') {
          this.error = 'Location data is not yet available'
        } else {
          this.error = data.error
        }
      }
      else {
        this.error = undefined
      }

      this.stopDataApi = data

      // Clear the previous features
      this.vectorSource.clear()

      if (data.driverName) {
        this.driverName = data.driverName
      } else {
        this.driverName = 'N/A'
      }

      this.vehicleExternalId = data.vehicleExternalId
      this.vehicleColor = data.vehicleColor
      this.vehicleMake = data.vehicleMake
      this.vehicleModel = data.vehicleModel
      this.vehicleLicensePlate = data.vehicleLicensePlate

      this.stopTimes = data.stopTimes

      this.calculateStops(data.stops)
      this.calculatePoints(data.points)
      // this.findExtraStops(data.stops)
      this.findStopADs()

      this.prepareDataForDisplay()
    },
    async setupComponent() {
      if (this.routeId === undefined) {
        this.error = 'No Route ID provided'
        this.prevParams = {
          routeId: String(this.routeId),
          date: String(this.date),
        }
        return
      }
      else if (this.date === undefined) {
        this.error = 'No date provided'
        this.prevParams = {
          routeId: String(this.routeId),
          date: String(this.date),
        }
        return
      }
      else {
        this.error = undefined
      }

      if (!fastDeepEquals(
          this.prevParams,
          {
            routeId: String(this.routeId),
            date: String(this.date),
          }
        )
      ) {
        this.getRouteDetail()

        // Initial update
        await this.updateMap()
        this.centered = true
      }

      // Update every 10 seconds if route is live
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
      if (this.routeCompleted === false) {
        this.intervalId = setInterval(this.updateMap, 10000)
      }
    },
    calculatePoints(resPoints) {
      if (resPoints === undefined) {
        this.allPoints = []
        return
      }

      this.allPoints = resPoints
      if (Array.isArray(resPoints) && resPoints.length > 0) {
        if (this.loggedBefore != '' && this.loggedBefore != undefined) {
          var pointsBefore = []
          for (let i = 0; i < resPoints.length; i++) {
            if (resPoints[i].loggedAtLocal <= this.loggedBefore) {
              pointsBefore.push(resPoints[i])
            }
          }
          resPoints = pointsBefore
        }

        for (let i = 0; i < resPoints.length - 1; i++) {
          if (resPoints[i].loggedAtLocal && resPoints[i+1].loggedAtLocal) {
            var date1 = new Date(`1970-01-01T${resPoints[i].loggedAtLocal}Z`)
            var date2 = new Date(`1970-01-01T${resPoints[i+1].loggedAtLocal}Z`)
            var diff = (date2 - date1) / 1000
            if (diff <= 30) {
              const lineCoords = [
                [ resPoints[i].longitude, resPoints[i].latitude ],
                [ resPoints[i+1].longitude, resPoints[i+1].latitude ],
              ]
              const route = new LineString(lineCoords).transform('EPSG:4326', 'EPSG:3857')
              const routeFeature = new Feature({
                type: 'route',
                geometry: route,
              })
              routeFeature.set('loggedAt', time.timeToDisplay(resPoints[i].loggedAtLocal))
              this.vectorSource.addFeature(routeFeature)
            }
          }
        }

        if (resPoints !== undefined && resPoints.length > 0){
          const points = resPoints.map((p) => [p.longitude, p.latitude])
          const currentPoint = transform(points[points.length - 1], 'EPSG:4326', 'EPSG:3857')
          const currentPointFeature = new Feature({
            type: 'currentPoint',
            geometry: new Point(currentPoint),
          })
          currentPointFeature.set('loggedAt', time.timeToDisplay(resPoints[resPoints.length - 1].loggedAtLocal))

          this.vectorSource.addFeature(currentPointFeature)

          if (!this.centered && this.allPoints.length !== 0) {
            this.map.getView().setCenter(currentPoint)
          }
        }
      }
    },
    sortStops(stops){
      stops.sort((a, b) => {
        const timeA = a.time.split(':')
        const timeB = b.time.split(':')
        const dateA = new Date()
        dateA.setHours(Number(timeA[0]), Number(timeA[1]), Number(timeA[2]), 0)
        const dateB = new Date()
        dateB.setHours(Number(timeB[0]), Number(timeB[1]), Number(timeB[2]), 0)
        return dateA - dateB
      })
    },
    calculateStops(resStops) {
      if (Array.isArray(resStops) && resStops.length > 0) {
        this.sortStops(resStops)
        const stops = resStops.map((p) => [p.longitude, p.latitude])
        const lastStop = stops.length - 1
        let schoolCoords
        stops.forEach((stop, i) => {
          if (!stop[0] || !stop[1]) {
            return
          }
          const stopPoint = transform(stop, 'EPSG:4326', 'EPSG:3857')
          const stopFeature = new Feature({
            type: 'stopPoint',
            name: (i + 1).toString(),
            geometry: new Point(stopPoint)
          })
          if (this.direction === 'Inbound' && i === lastStop) {
            stopFeature.set('school', true)
            schoolCoords = stopPoint
          } else if (this.direction === 'Outbound' && i === 0) {
            stopFeature.set('school', true)
            schoolCoords = stopPoint
          }
          if (resStops[i].loggedAt) {
            stopFeature.set('loggedAt', this.timeToDisplay(resStops[i].loggedAt))
          }
          this.vectorSource.addFeature(stopFeature)
        })
        this.stops = resStops
        if (this.stops[lastStop].loggedAt) {
          this.routeCompleted = true
        }

        if (!this.centered && this.allPoints.length === 0) {
          this.map.getView().setCenter(schoolCoords)
        }
      }
    },
    toggleBox(feature) {
      return feature
    },
    onMouseOver(studentId) {
      this.mouseOverStudentId = studentId
    },
    // COMMENTED FOR PRODUCTION RELEASE
    // findExtraStops(resStops) {
    //   if (Array.isArray(resStops) && resStops.length > 0) {
    //     this.extraStops = []
    //     let points = this.allPoints
    //     for (let i = 0 ; i < resStops.length; i++) {
    //       let stopPoint = [resStops[i].longitude, resStops[i].latitude]
    //       let closestPoint = this.closestToPoint(stopPoint, this.allPoints.map((p) => [p.longitude, p.latitude]))
    //       let distanceInFeet = undefined
    //       if (closestPoint) {
    //         distanceInFeet = this.calculateDistance(stopPoint, closestPoint)
    //       }
    //       this.stops[i].closestPoint = distanceInFeet
    //       let isSchool = false
    //       if(this.direction === 'Inbound' && i == (this.stops.length - 1)) {
    //         isSchool = true
    //       } else if (this.direction === 'Outbound' && i == 0) {
    //         isSchool = true
    //       }
    //       if (
    //         closestPoint &&
    //         ((!isSchool && distanceInFeet > 100) || (isSchool && distanceInFeet > 1320))
    //       ){
    //         let closestTime = new Date(points[0].loggedAt) - new Date(this.stopTimes[i].completedAt)
    //         let closestTimePoint = points[0]
    //         for (let j = 1; j < points.length; j++) {
    //           let dt = new Date(points[j].loggedAt) - new Date(this.stopTimes[i].completedAt)
    //           if (Math.abs(dt) < Math.abs(closestTime)) {
    //             closestTime = dt
    //             closestTimePoint = points[j]
    //           }
    //         }
    //         let isSchool = false
    //         if(this.direction === 'Inbound' && i == (this.stopTimes.length - 1)) {
    //           isSchool = true
    //         } else if (this.direction === 'Outbound' && i == 0) {
    //           isSchool = true
    //         }
    //         let point = [closestTimePoint.longitude, closestTimePoint.latitude]
    //         this.extraStops.push(point)
    //         const extraStopPoint = transform(point, 'EPSG:4326', 'EPSG:3857')
    //         const extraStopFeature = new Feature({
    //           type: 'extraStopPoint',
    //           geometry: new Point(extraStopPoint)
    //         })
    //         extraStopFeature.set('loggedAt', this.timeToDisplay(resStops[i].loggedAt))
    //         if (isSchool) {
    //           extraStopFeature.set('school', true)
    //         }
    //         this.vectorSource.addFeature(extraStopFeature)
    //       }
    //     }
    //   }
    // },
  },
  async mounted() {
    this.initializeMap()
    await this.setupComponent()
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  watch: {
    async routeId() {
      await this.setupComponent()
    },
    async date() {
      await this.setupComponent()
    },
    async loggedBefore() {
      this.vectorSource.clear()
      this.calculatePoints(this.allPoints)
      this.calculateStops(this.stops)
      // this.findExtraStops(this.stops)
      this.findStopADs()
    }
  },
  computed: {
    vehicleDisplayName() {
      return [this.vehicleColor, this.vehicleMake, this.vehicleModel]
        .filter(Boolean)
        .join(' ')
    },
    showVehicleInfo() {
      return Boolean(this.vehicleExternalId || this.vehicleDisplayName || this.vehicleLicensePlate)
    },
    students() {
      if (this.studentsApi) {
        return this.studentsApi
      }
      else if (this.studentsProp) {
        return this.studentsProp
      }
      return undefined
    },
    stopTableColumns() {
      if (this.showRouteTimes) {
        return ['Stop #', 'Scheduled', 'Recorded Complete', 'Arrived', 'Departed', 'Students']
      } else {
        return ['Stop #', 'Scheduled', 'Recorded Complete', 'Students']
      }
    },
    stopTableColumnTitles() {
      if (this.showRouteTimes) {
        return [
          'Stop number',
          'Scheduled stop time',
          'Time driver recorded stop as complete',
          'Time driver arrived within 100 feet from stop',
          'Time driver departed 100 feet from stop',
          'List of students assigned to stop',
        ]
      } else {
        return [
          'Stop number',
          'Scheduled stop time',
          'Time driver recorded stop as complete',
          'List of students assigned to stop',
        ]
      }
    }

  }
}
</script>
